import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// 비로그인 사용자 좋아요 중복 방지용 익명 방문자 ID
export function getVisitorId() {
  try {
    let vid = localStorage.getItem("nc_visitor_id");
    if (!vid) {
      vid = (crypto?.randomUUID?.() || `v-${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem("nc_visitor_id", vid);
    }
    return vid;
  } catch {
    return `v-${Date.now()}`;
  }
}

